import {httpsCallable} from 'firebase/functions';
import {firebaseFunctions} from './firebase';

interface PromoteUserResponse {
  status: 'success';
  message: string;
}

interface DemoteUserResponse {
  status: 'success';
  message: string;
}

interface DeleteUserResponse {
  status: 'success';
  message: string;
}

const promoteUserToAdmin = async (
  userId: string,
): Promise<PromoteUserResponse> => {
  const callableFunc = httpsCallable<
    {userId: string; role: 'admin' | 'localAdmin'},
    PromoteUserResponse
  >(firebaseFunctions, 'onPromoteUser');

  return callableFunc({userId, role: 'admin'})
    .then(result => {
      console.log('User promoted to admin:', result.data);
      return result.data;
    })
    .catch(error => {
      console.error('Error promoting user to admin:', error);
      throw error;
    });
};

const demoteUserFromAdmin = async (
  userId: string,
): Promise<DemoteUserResponse> => {
  const callableFunc = httpsCallable<
    {userId: string; role: 'admin' | 'localAdmin'},
    DemoteUserResponse
  >(firebaseFunctions, 'onDemoteUser');

  return callableFunc({userId, role: 'admin'})
    .then(result => {
      console.log('User demoted from admin:', result.data);
      return result.data;
    })
    .catch(error => {
      console.error('Error demoting user from admin:', error);
      throw error;
    });
};

const promoteUserToLocalAdmin = async (
  userId: string,
): Promise<PromoteUserResponse> => {
  const callableFunc = httpsCallable<
    {userId: string; role: 'admin' | 'localAdmin'},
    PromoteUserResponse
  >(firebaseFunctions, 'onPromoteUser');

  return callableFunc({userId, role: 'localAdmin'})
    .then(result => {
      console.log('User promoted to local admin:', result.data);
      return result.data;
    })
    .catch(error => {
      console.error('Error promoting user to local admin:', error);
      throw error;
    });
};

const demoteUserFromLocalAdmin = async (
  userId: string,
): Promise<DemoteUserResponse> => {
  const callableFunc = httpsCallable<
    {userId: string; role: 'admin' | 'localAdmin'},
    DemoteUserResponse
  >(firebaseFunctions, 'onDemoteUser');

  return callableFunc({userId, role: 'localAdmin'})
    .then(result => {
      console.log('User demoted from local admin:', result.data);
      return result.data;
    })
    .catch(error => {
      console.error('Error demoting user from local admin:', error);
      throw error;
    });
};

const deleteUser = async (userId: string): Promise<DeleteUserResponse> => {
  const callableFunc = httpsCallable<{userId: string}, DeleteUserResponse>(
    firebaseFunctions,
    'onDeleteUser',
  );

  return callableFunc({userId})
    .then(result => {
      console.log('User deleted:', result.data);
      return result.data;
    })
    .catch(error => {
      console.error('Error deleting user:', error);
      throw error;
    });
};

export const admin = {
  promoteUserToAdmin,
  demoteUserFromAdmin,
  promoteUserToLocalAdmin,
  demoteUserFromLocalAdmin,
  deleteUser,
};
